﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("../../../api/admin/classes/models");
class LPMessageOrder {
    constructor(message) {
        this.order = new models_1.Order(message.message);
    }
}
exports.default = LPMessageOrder;
//# sourceMappingURL=LPMessageOrder.js.map